import { getFromBreakpoint } from '@vakantiesnl/components/src/styles/breakpoints';
import { makeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';

export const useCustomStyles = makeStyles()((theme) => ({
	selectContainer: {
		display: 'flex',
		flexDirection: 'column',
		gap: theme.spacing.small,

		[getFromBreakpoint('md')]: {
			flexDirection: 'row',
		},
	},
	flightFilterMenuContainer: {
		display: 'flex',
		flexDirection: 'column',
		gap: theme.spacing.small,
		backgroundColor: theme.palette.neutral[0],
		width: '100%',
		position: 'sticky',
		alignSelf: 'start',
		zIndex: theme.zIndex.lifted,
		top: 0,
		marginBottom: theme.spacing.large,

		[getFromBreakpoint('md')]: {
			marginBottom: 0,
		},
	},
}));
